import React      from 'react';

export const PseudoId = ({ value, record }) => {
  if(!record.result) {
    return <i>--</i>;
  }
  const { pseudonym } = record.result;
  return (pseudonym) ? 'PSN-' + pseudonym.id : <i>--</i>;
}
